import React, { useState } from "react";
import PagesHeader from "@components/PagesHeader";
import StickyButtonNav from "@components/StickyButtonNav";
import "./style.scss";
import { navItems } from ".";
import SectionHeader from "../../components/SectionHeader";
import UnderlineButton from "../../components/UnderlineButton";
import ReceivedAwardCard from "../../components/ReceivedAwardCard";
import PlaceholderIcon from "./img/placeholder-icon.svg?react";
import Button from "@components/Button";
import {
  COUPON_CACHE_TIME,
  COUPON_STALE_TIME,
  getCouponList,
} from "../../api/coupon";
import { useQuery } from "@tanstack/react-query";
import spider from "../Activities/Activities/Idents/quiz_7/img/spider.svg";
import Object from "@components/FindGame";

function EmptyPlaceholder() {
  return (
    <div className="empty-placeholder">
      <PlaceholderIcon />
      <div className="content">
        <p>
          Du hast <strong>noch keine Gutscheine</strong>
        </p>
        <h3>
          <strong>Jetzt Gutscheine entdecken</strong>
        </h3>
        <div className="button-wrapper">
          <Button href="/coupons" btnClass="yellow">
            Wähle einen Gutschein aus
          </Button>
          <Button href="/activities" btnClass="outline yellow">
            Punkte sammeln
          </Button>
        </div>
      </div>
    </div>
  );
}

export default function ReceivedCouponsPage() {
  const [showHistory, setShowHistory] = useState(false);

  const { data } = useQuery({
    queryKey: ["coupon-list", "include-gamereward"],
    queryFn: () => getCouponList(undefined, { includeGameRewards: true }),
    staleTime: COUPON_STALE_TIME,
    cacheTime: COUPON_CACHE_TIME,
    suspense: true,
  });

  const receivedActive = data?.coupon.filter(
    (c) => c.catalogue.ident !== "mclaren_limited"
  );

  const notUsed = receivedActive.filter(
    (e) => !e.usedAt && new Date() - new Date(e.expiresAt) < 0
  );

  const used = receivedActive.filter(
    (e) => e.usedAt || new Date() - new Date(e.expiresAt) >= 0
  );

  return (
    <section className="received-coupons-page">
      <PagesHeader>
        <strong> Punkte eintauschen </strong>
      </PagesHeader>
      {/* <Object
        bottom="object-5"
        uuid={"5ccb5054-1517-466f-84b2-6da31eed5532"}
        image={spider}
        innerImage={spider}
        copy={`<p style="font-size:20px"><strong >Glückwunsch!</strong></p><br/>Du hast eine Spinne gefangen!`}
      /> */}
      <div className="active-list-wrapper">
        <StickyButtonNav items={navItems} />
        <SectionHeader>
          Sofort <strong>einlösbar</strong>
        </SectionHeader>
        <div className={`active-list ${notUsed.length === 0 ? "empty" : ""}`}>
          {notUsed.length === 0 ? (
            <EmptyPlaceholder />
          ) : (
            <>
              {notUsed.map((e, index) => (
                <ReceivedAwardCard
                  content={e.catalogue.content}
                  disabled={false}
                  expires={e.expiresAt}
                  key={index}
                  brands={e.catalogue.brands}
                  mobileImg={e?.catalogue?.thumbnail?.file?.url}
                  uuid={e.uuid}
                />
              ))}
            </>
          )}
        </div>
      </div>
      <div className="history-list-wrapper">
        <UnderlineButton
          onClick={() => setShowHistory((prev) => !prev)}
          icon={showHistory ? "up-arrow-blue" : "down-arrow-blue"}
        >
          {showHistory ? "Geschichte ausblenden" : "Geschichte anzeigen"}
        </UnderlineButton>
        <div className="history-list">
          {showHistory &&
            used.map((e, index) => (
              <ReceivedAwardCard
                content={e.catalogue.content}
                disabled={true}
                expires={e.expiresAt}
                key={index}
                brands={e.catalogue.brands}
                mobileImg={e.catalogue.thumbnail.file.url}
                imgDesc={e.catalogue.thumbnail?.metadata?.imgDesc}
                uuid={e.uuid}
              />
            ))}
        </div>
      </div>
    </section>
  );
}
